<header class="short-header">
  <div
    *ngIf="type == 'house'"
    fxLayout="column"
    fxLayoutAlign="space-between center"
  >
    <div
      fxLayout="row"
      fxLayoutAlign="center center"
      class="title-container"
    >
      <h2>
        Locuinte
        <span class="after-title">
          {{ agencyService.agency.name }}
        </span>
      </h2>
    </div>
    <div
      class="property-search-container"
      fxLayout="column"
      fxLayoutAlign="center start"
    >
      <h4
        class="property-search-title"
      >
        Filtrează locuințe:
      </h4>
      <div
        class="filters-container"
      >
        <form
          fxLayout="column"
          fxLayoutAlign="center start"
          #form="ngForm"
          class="filters-form"
        >
          <div
            fxLayout="row wrap"
            fxLayoutAlign="space-between center"
            class="filters-row"
          >
            <mat-form-field
              class="dropdown-filter room-number-filter"
            >
              <mat-select
                [(ngModel)]="getPropertySearch().room_count"
                name="room_count"
                [placeholder]="'Număr camere'"
              >
                <mat-option
                  *ngFor="let roomCount of [2, 3]"
                  [value]="roomCount"
                >
                  {{ roomCount }} camere
                </mat-option>
              </mat-select>

            </mat-form-field>
            <div
              class="slider-item-container"
              fxFlex="100%"
              fxLayout="column"
            >
              <h5
                fxFlex
                class="slider-item-title"
              >
                Buget:
              </h5>
              <div
                class="slider-filter-container"
                fxFlex
              >
                <app-slider-base
                  [(minValue)]="getPropertySearch().min_buy_price_eur"
                  [(maxValue)]="getPropertySearch().max_buy_price_eur"
                  [min]="advancedLimits.min_buy_price_eur"
                  [max]="advancedLimits.max_buy_price_eur"
                >
                </app-slider-base>
                <div
                  class="slider-value-container"
                >
                  <div
                    *ngIf="getPropertySearch().min_buy_price_eur || getPropertySearch().max_buy_price_eur"
                  >
                    {{ getPropertySearch().min_buy_price_eur | number:'.0-0' }} EUR - {{ getPropertySearch().max_buy_price_eur | number:'.0-0' }} EUR
                  </div>
                </div>
              </div>
            </div>
            <div
              class="slider-item-container"
              fxFlex="100%"
              fxLayout="column"
            >
              <h5
                fxFlex
                class="slider-item-title"
              >
                Suprafata:
              </h5>
              <div
                fxFlex
                class="slider-filter-container"
              >
                <app-slider-base
                  [(minValue)]="getPropertySearch().min_size_sqm"
                  [(maxValue)]="getPropertySearch().max_size_sqm"
                  [min]="advancedLimits.min_size_sqm"
                  max="98"
                >
                </app-slider-base>
                <div
                  class="slider-value-container"
                >
                  <div
                    *ngIf="getPropertySearch().min_size_sqm || getPropertySearch().max_size_sqm"
                  >
                    {{ getPropertySearch().min_size_sqm | number:'.0-0' }} m<sup>2</sup> - {{ getPropertySearch().max_size_sqm | number:'.0-0' }} m<sup>2</sup>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            fxLayout="row wrap"
            fxLayoutAlign="space-between center"
            class="filters-row"
          >
            <mat-form-field
              class="dropdown-filter"
            >
              <mat-select
                [(ngModel)]="getPropertySearch().availability"
                name="availability"
                [placeholder]="'Disponibilitate'"
              >
                <mat-option
                  [value]="null"
                >
                  Toate
                </mat-option>
                <mat-option
                  [value]="'available'"
                >
                  Disponibilă
                </mat-option>
                <mat-option
                  [value]="'unavailable'"
                >
                  Indisponibilă
                </mat-option>
                <mat-option
                  [value]="'sold'"
                >
                  Vandută
                </mat-option>
                <mat-option
                  [value]="'reserved'"
                >
                  Rezervată
                </mat-option>
              </mat-select>

            </mat-form-field>
            <mat-form-field
              class="dropdown-filter"
            >
              <mat-select
                multiple
                [(ngModel)]="getPropertySearch().floor_ids"
                name="floors"
                [placeholder]="'Etaj'"
              >
                <mat-option
                  *ngFor="let floor of advancedLimits.floors"
                  [value]="floor.id"
                >
                  {{ floor.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <button
              mat-raised-button
              color="secondary"
              (click)="resetFilters(); resetSliderSearch();"
              class="reset-filters-button"
            >
              resetează filtrele
            </button>
            <button
              mat-raised-button
              color="secondary"
              (click)="getPropertySearch().for_sale=1; refreshProperties();"
              class="search-properties-button"
            >
              caută
            </button>
          </div>
        </form>
      </div>
      <div
        fxLayout="column"
        fxLayout.gt-xs="row wrap"
        fxLayoutAlign="center center"
        fxLayoutAlign.gt-xs="start center"
        class="bottom-filters"
      >
        <mat-form-field
          class="dropdown-filter sort-container"
        >
          <mat-select
            [(ngModel)]="getPropertySearch().sort"
            name="sort"
            [placeholder]="'Sortează după'"
          >
            <mat-option
              *ngFor="let sort of sortItems"
              [value]="sort.id"
            >
              {{ sort.text }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          class="dropdown-filter sort-container"
        >
          <mat-select
            [(ngModel)]="getPropertySearch().project_id"
            name="project_id"
            [placeholder]="'Alege proiecte'"
          >
            <mat-option
              *ngFor="let project of projects"
              [value]="project.id"
            >
              {{ project.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div
    *ngIf="type === 'project'"
    fxLayout="column"
    fxLayoutAlign="space-between center"
  >
    <div
      fxLayout="row"
      fxLayoutAlign="center center"
      class="title-container"
    >
      <h2>
        Portofoliu
        <span class="after-title">
          {{ agencyService.agency.name }}
        </span>
      </h2>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="center center"
      class="filter-form-container"
    >
      <form>
        <div
          fxLayout="column"
          fxLayout.gt-sm="row"
          fxLayoutAlign="center center"
          class="buttons-wrapper"
        >
          <a
            *ngFor="let status of [null, 'available', 'sold_out']"
            mat-raised-button
            color="secondary"
            [class.active]="projectSearch.sale_status === status"
            (click)="filterProjects(status); removeSomeProjects();"
          >
            {{ status === null ? 'vezi toate' : '' }}
            {{ status === 'available' ? 'disponibil' : '' }}
            {{ status === 'sold_out' ? 'vândut' : '' }}
          </a>
        </div>
      </form>
    </div>
  </div>
</header>

<div
  #section
>
  <section
    *ngIf="type == 'house'"
    class="properties"
    [style.minHeight.px]="pageHeight"
    (window:scroll)="onScroll()"
  >
    <div
      class="spinner center"
      *ngIf="properties.length == 0 && apiLoading == false"
    >
      Momentan nu există nici o proprietate cu specificațiile alese, vă rugăm reveniți.
    </div>
    <div
      class="spinner"
      *ngIf="apiLoading"
      style="display: flex; justify-content: center; align-items: center;"
    >
      <div class="sk-circle">
        <div class="sk-circle1 sk-child"></div>
        <div class="sk-circle2 sk-child"></div>
        <div class="sk-circle3 sk-child"></div>
        <div class="sk-circle4 sk-child"></div>
        <div class="sk-circle5 sk-child"></div>
        <div class="sk-circle6 sk-child"></div>
        <div class="sk-circle7 sk-child"></div>
        <div class="sk-circle8 sk-child"></div>
        <div class="sk-circle9 sk-child"></div>
        <div class="sk-circle10 sk-child"></div>
        <div class="sk-circle11 sk-child"></div>
        <div class="sk-circle12 sk-child"></div>
      </div>
    </div>
    <div
      fxLayout="row wrap"
      fxLayoutAlign="center center"
      class="properties-list"
    >
      <a
        *ngFor="let property of properties"
        class="property-item"
        [routerLink]="['/', property.property_type, property.friendly_id]"
      >
        <app-property [property]="property" [type]="'property'"></app-property>
      </a>
    </div>
  </section>
</div>

<div
  #listSection
>
  <ng-template
    [ngIf]="type === 'project'"
  >
    <section
      class="properties"
      (window:scroll)="onScroll()"
    >
      <div
        fxLayout="row wrap"
        fxLayoutAlign="center center"
        class="projects-list"
        [style.minHeight.px]="pageHeight"
      >
        <a
          *ngFor="let project of projects"
          class="project-item"
          [routerLink]="['/portofoliu', project.id]"
        >
          <app-property
            [project]="project"
            [type]="'project'"
          >
          </app-property>
        </a>
      </div>
    </section>
  </ng-template>
</div>



// WEBPACK FOOTER //
// ./src/app/houses/houses.component.html